import React from "react";
import PropTypes from "prop-types";
import useStyles from "./formStyles";
import { FormControl, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarIcon from "../../assets/images/Svg/CalendarIcon";
import { DateTime } from "luxon";
import { DATETIME_FORMAT } from "../../utility/Utils";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { localMap } from "../../utility/Enum";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useTranslation } from "../../context/Internationalization";

const DatePickerRenderer = ({
  name,
  value = DateTime.now(),
  onChange,
  disabled,
  minDate = DateTime.fromFormat("2020/01/01 00:00", DATETIME_FORMAT),
  maxDate = DateTime.fromFormat("2099/01/01 00:00", DATETIME_FORMAT),
  error = "",
  label,
  views,
  inputFormat = "dd/MM/yyyy",
  placeholder,
}) => {
  const { lang } = useTranslation();
  const styles = useStyles();

  const onChangeDate = (value) => {
    onChange({ target: { name, value } });
  };

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterLuxon}
        adapterLocale={localMap[lang]}
      >
        <Stack direction={"column"} spacing={0.5} sx={{ width: "100%" }}>
          <span className={styles.label}>{label}</span>
          <FormControl fullWidth>
            <DatePicker
              name={name}
              format={inputFormat}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              value={value || null}
              placeholder={placeholder}
              InputAdornmentProps={{ position: "start" }}
              slotProps={{
                openPickerIcon: CalendarIcon,
                textField: {
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& fieldset": {
                        borderColor: styles.input.borderColor,
                      },
                      "&:hover fieldset": {
                        borderColor: styles.input.borderColor,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: styles.input.borderColor,
                      },
                    },
                  },
                  helperText: error,
                  error: !!error,
                  classes: { notchedOutline: styles.input },
                  style: { height: "40px" },
                  InputProps: {
                    style: { height: "40px" },
                  },
                  formHelperText: {
                    classes: {
                      root: styles.helperText,
                    },
                  },
                },
              }}
              onChange={onChangeDate}
              views={views}
            />
          </FormControl>
        </Stack>
      </LocalizationProvider>
    </>
  );
};

DatePickerRenderer.propTypes = {};

export default DatePickerRenderer;
